import React from "react";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";

const MaterialFilters = ({ filters, onFilterChange }) => {
  const handleFilterChange = (filterName, value) => {
    onFilterChange({
      ...filters,
      [filterName]: value,
    });
  };

  return (
    <div className="flex items-center gap-4">
      {/* Unit Filter */}
      <FormControl size="small" sx={{ minWidth: 200 }}>
        <InputLabel id="unit-filter-label">Filter by Unit</InputLabel>
        <Select
          labelId="unit-filter-label"
          id="unit-filter"
          value={filters.unit}
          label="Filter by Unit"
          onChange={e => handleFilterChange("unit", e.target.value)}>
          <MenuItem value="">All</MenuItem>
          <MenuItem value="meters">Meters</MenuItem>
          <MenuItem value="yards">Yards</MenuItem>
          <MenuItem value="pieces">Pieces</MenuItem>
          <MenuItem value="kg">Kilograms</MenuItem>
        </Select>
      </FormControl>

      {/* Sort By Filter */}
      <FormControl size="small" sx={{ minWidth: 200 }}>
        <InputLabel id="sort-filter-label">Sort By</InputLabel>
        <Select
          labelId="sort-filter-label"
          id="sort-filter"
          value={filters.sortBy}
          label="Sort By"
          onChange={e => handleFilterChange("sortBy", e.target.value)}>
          <MenuItem value="">None</MenuItem>
          <MenuItem value="name_asc">Name (A-Z)</MenuItem>
          <MenuItem value="name_desc">Name (Z-A)</MenuItem>
          <MenuItem value="quantity_asc">Quantity (Low to High)</MenuItem>
          <MenuItem value="quantity_desc">Quantity (High to Low)</MenuItem>
          <MenuItem value="price_asc">Price (Low to High)</MenuItem>
          <MenuItem value="price_desc">Price (High to Low)</MenuItem>
        </Select>
      </FormControl>
    </div>
  );
};

export default MaterialFilters;
